import * as React from 'react';
import * as styles from './styles.scss';
import { PersonaIcon } from 'owa-timestream-asset-sdk';
import type Message from 'owa-service/lib/contract/Message';
import classNames from 'classnames';
import popoutMailItemFromMessage from '../utils/popoutMailItemFromMessage';
import loc from 'owa-localize';
import { noPreview } from 'owa-locstrings/lib/strings/getCleanPreview.locstring.json';
import { messageToolTip } from '../mailItem.locstring.json';

export interface MessageItemStyles {
    body: string;
    preview: string;
    unread: string;
    timeAndPersonaWrapper: string;
}

const subjectStyle = styles.subject;
const unreadSubjectStyle = classNames(subjectStyle, styles.unread);

export default function MessageItem(props: {
    message: Message;
    messageItemStyle: MessageItemStyles;
    onMessageClicked?: () => void;
    showSubject?: boolean;
}) {
    const { message, messageItemStyle, onMessageClicked, showSubject } = props;
    const previewText = message.Preview || loc(noPreview);

    const openMessage = React.useCallback(() => {
        if (onMessageClicked) {
            onMessageClicked();
        } else {
            popoutMailItemFromMessage(message);
        }
    }, [onMessageClicked, message]);

    const onDoubleClick = (e: React.MouseEvent) => {
        openMessage();
    };
    const onEnter = (e: React.KeyboardEvent) => {
        if (e.key == 'Enter') {
            openMessage();
        }
    };

    const onMouseDown = (e: React.MouseEvent) => {
        // prevent focus state from sticking when message is clicked
        e.preventDefault();
    };

    return (
        <div
            className={messageItemStyle.body}
            onDoubleClick={onDoubleClick}
            title={loc(messageToolTip)}
            onMouseDown={onMouseDown}
            onKeyDown={onEnter}
            role="button"
            tabIndex={0}>
            <div className={messageItemStyle.timeAndPersonaWrapper}>
                {message?.Sender?.Mailbox && (
                    <PersonaIcon
                        tabIndex={0}
                        name={message.Sender.Mailbox.Name as string}
                        emailAddress={message.Sender.Mailbox.EmailAddress as string}
                    />
                )}
            </div>
            <div tabIndex={0}>
                {showSubject && (
                    <h2 className={message.IsRead ? subjectStyle : unreadSubjectStyle}>
                        {message.Subject}
                    </h2>
                )}
                {!!previewText && <div className={messageItemStyle.preview}>{previewText}</div>}
            </div>
        </div>
    );
}
